import { License } from '@webdev/user-management';
import React from 'react';
import { LicenseAssignmentContext } from './LicenseAssignmentContext';
import { LicenseAssignmentModal } from './Modal';
import { LicenseAssignmentModalContent } from './ModalContent';

interface LicenseAssignmentProps {
  licenseData: { licenseId?: License['id']; license?: { subscriptions?: string[] } };
}

export const LicenseAssignment: React.FC<LicenseAssignmentProps> = ({
  licenseData: { licenseId, license },
}) => {
  /**
   * Also check for 'null' as string, because nulled licenseId gets
   * converted to string anywhere in the code.
   */
  if (!licenseId || !license?.subscriptions?.[0] || licenseId === 'null') {
    return null;
  }

  return (
    <div className='f5 subscription__license-key subscription__amend-options'>
      <LicenseAssignmentContext licenseId={licenseId}>
        <LicenseAssignmentModal>
          <LicenseAssignmentModalContent />
        </LicenseAssignmentModal>
      </LicenseAssignmentContext>
    </div>
  );
};
